import type { Role } from '@manitype/core';

const RANK: Record<Role, number> = { user: 0, editor: 1, admin: 2, superadmin: 3 };

/** Comprobación de rol en la interfaz (el servidor la vuelve a validar siempre). */
export function hasRole(role: Role, minimum: Role): boolean {
  return RANK[role] >= RANK[minimum];
}
